export function agentGraphUrl(agentId) {
  const base = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';
  return `${base}/agents/${agentId}/graph`;
}
